import React from 'react';
import CountryComparisonTitleAndFilters from '../../partials/country-comparison-title-and-filters/country-comparison-title-and-filters.component';
import CountryComparisonResults from '../../partials/country-comparison-results/country-comparison-results.component';
import PageHeader from '../../layout/page-header/page-header.component';
import Page from '../../layout/page/page.component';
import { useAppState } from '../../../hooks/use-app-state.hook';
import { useCountryProfileFilters } from '../../../hooks/use-country-profile-filters.hook';
import { getTaxonomyValidation, toCountryProfileList } from '../../../utils';

const CountryComparisonPage: React.FC = () => {
    const [{
        taxonomies: allTaxonomies
    }, {
        getCountryProfileResultList,
        getPage,
        getTaxonomies,
    }] = useAppState();
    const [filters, changeFilters] = useCountryProfileFilters();
    const taxonomies = getTaxonomies(filters);
    const countryProfileList = toCountryProfileList(
        getCountryProfileResultList({
            ...filters,
            datetime: filters.datetime,
        })
    );
    const [, invalidCountryIds] = getTaxonomyValidation(
        'countries', allTaxonomies, taxonomies.countries, filters.countryIds
    );

    const page = getPage('Country Comparison');
    const pageTitle = 'Compare up to 5 countries';
     
    return (
        <Page>
            { page && (
                <PageHeader>
                    <CountryComparisonTitleAndFilters
                        title={ pageTitle }
                        description={ page.html }
                        taxonomies={ taxonomies }
                        filters={ filters }
                        onChangeFilters={ changeFilters }/>
                </PageHeader>
            ) }
            <CountryComparisonResults
                countryProfileList={ countryProfileList }
                invalidCountryIds={ invalidCountryIds }
                filters={ filters }
                onChangeFilters={ changeFilters }/>
        </Page>
    );
};

export default CountryComparisonPage;
